import {
  useGerarAnaliseLegibilidade,
  useGerarAnaliseLegibilidadeVozPassiva,
  useGerarAnaliseLegibilidadeOrtografia,
  usegerarAnaliseLegibilidaGramatica,
} from '@api/controllers/analiseLegibilidade';
import { useAnalisesPostParametros } from './useAnalisesPostParametros';
import { useEffect, useState } from '@wordpress/element';
import { POST_ID } from '../../routes/Variables';
import { useActionParam } from '@api/actions/action';
import { useGerarAnaliseSeo, useGerarAnaliseSeoIa, useGerarAnaliseSeoNaoTextual } from '@api/controllers/analiseSeo';
import ContextTela from '@pages/DicasOtimizacao/telaContext';
import { useContext } from '@wordpress/element';

export const useAnalisesPostGerar = ({ idPost = POST_ID, tipo = '' }) => {
  const [resultado, setResultado] = useState({
    analise: null,
    erro: null,
    carregando: false,
  });

  const { telaOposta } = useContext(ContextTela);
  const { mutateAsync: gerarAnaliseLegibilidade } = useGerarAnaliseLegibilidade();
  const { mutateAsync: gerarAnaliseLegibilidadeVozPassiva } = useGerarAnaliseLegibilidadeVozPassiva();
  const { mutateAsync: gerarAnaliseLegibilidadeOrtografia } = useGerarAnaliseLegibilidadeOrtografia();
  const { mutateAsync: gerarAnaliseLegibilidaGramatica } = usegerarAnaliseLegibilidaGramatica();
  const { mutateAsync: gerarAnaliseSeo } = useGerarAnaliseSeo();
  const { mutateAsync: gerarAnaliseSeoNaoTextual } = useGerarAnaliseSeoNaoTextual();
  const { mutateAsync: gerarAnaliseSeoTextualIa } = useGerarAnaliseSeoIa();

  const metodosAnalises = {
    legibilidade: gerarAnaliseLegibilidade,
    legibilidadeVozPassiva: gerarAnaliseLegibilidadeVozPassiva,
    legibilidadeOrtografia: gerarAnaliseLegibilidadeOrtografia,
    legibilidadeGramatica: gerarAnaliseLegibilidaGramatica,
    textual: gerarAnaliseSeo,
    nao_textual: gerarAnaliseSeoNaoTextual,
    textual_ia: gerarAnaliseSeoTextualIa
  };

  const { tipoEditor, parametros, obterParametro } = useAnalisesPostParametros({ idPost, tipo });
  const { mutateAsync: salvarBancoWp, isSuccess } = useActionParam();

  useEffect(() => {
    if (isSuccess) {
      document.dispatchEvent(new CustomEvent(`analise-${telaOposta}-${tipo}`, {
        detail: {
          status: 'FINALIZADO'
        }
      }));
    }
  }, [isSuccess])

  const gerarAnaliseComParametros = async () => {
    if (parametros?.blocos) {
      if (!idPost) {
        setResultado(prev => ({
          ...prev,
          erro: new Error('ID do post não fornecido!'),
          carregando: false,
        }));
        return;
      }

      try {
        setResultado(prev => ({ ...prev, carregando: true, erro: null }));

        const res = await metodosAnalises[tipo](parametros);

        if (!res?.data) {
          setResultado({
            analise: [],
            erro: null,
            carregando: false,
          });
          return;
        }

        setResultado({ analise: res?.data, carregando: false, erro: null });
        salvarBancoWp({
          action: 'salvar_analises',
          param: {
            post_id: parseInt(idPost, 10),
            tipo,
            analises: JSON.stringify(res?.data),
          },
        });
      } catch (error) {
        console.warn(`ERRO EM analise-${telaOposta}-${tipo}: error: ${JSON.stringify(error)}`)
        setResultado(prev => ({
          ...prev,
          erro: 'Ocorreu um erro inesperado ao tentar gerar a análise!',
          carregando: false,
        }));
      }
    }

    if (!parametros?.blocos) {
      obterParametro();
    }
  };

  useEffect(() => {
    if (tipoEditor === 'wp') return;

    if (parametros?.blocos) gerarAnaliseComParametros();
    if (!parametros?.blocos) obterParametro();
  }, [parametros, tipo]);

  return {
    gerarAnalise: gerarAnaliseComParametros,
    resultado,
  };
};
